export const isUserPlanExpired = () => {
  const trialFlag = localStorage.getItem("_s43");
  const isTrialExpired = trialFlag ? JSON.parse(atob(trialFlag)) : null;
  return isTrialExpired;
};

export const getUserProfile = () => {
  const profile = localStorage.getItem("userProfile");
  return profile ? JSON.parse(profile) : {};
};
export const getPlanInfo = () => {
  const plan = localStorage.getItem("verifiedUserPlan");

  if (!plan || plan === "undefined") {
    return {}; // return empty object if not valid
  }

  try {
    return JSON.parse(plan);
  } catch (e) {
    console.error("Invalid JSON in verifiedUserPlan:", e);
    return {};
  }
};

export const setEncodedUserProfile = (userProfile) => {
  // Convert the user profile object to a JSON string
  const userProfileString = JSON.stringify(userProfile);
  const encodedUserProfile = btoa(userProfileString);
  localStorage.setItem("_s54", encodedUserProfile); //key for encoded data
};

export const getEncodedUserProfile = () => {
  const encodedProfile = localStorage.getItem("_s54");

  if (encodedProfile) {
    const decodedProfileString = atob(encodedProfile);
    return JSON.parse(decodedProfileString);
  }
  return {};
};
